import { LoadingOutlined } from "@ant-design/icons";

export default function Loading() {
  return (
    <div className="loading-global">
      <LoadingOutlined className="loading-icon" />
    </div>
  );
}
